export const USA = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_11011_9005)">
                <path
                    d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
                    fill="white"
                />
                <path
                    d="M11.5654 11.9998H22.0002C22.0002 11.0972 21.8799 10.2229 21.6557 9.39111H11.5654V11.9998Z"
                    fill="#D80027"
                />
                <path
                    d="M11.5654 6.78205H20.5325C19.9203 5.78314 19.1376 4.90021 18.225 4.17334H11.5654V6.78205Z"
                    fill="#D80027"
                />
                <path
                    d="M12.0002 22.0001C14.3537 22.0001 16.5169 21.1866 18.2251 19.8262H5.77539C7.48359 21.1866 9.64676 22.0001 12.0002 22.0001Z"
                    fill="#D80027"
                />
                <path
                    d="M3.46797 17.2166H20.5325C21.0239 16.4147 21.4051 15.5381 21.6557 14.6079H2.34473C2.59539 15.5381 2.97652 16.4147 3.46797 17.2166Z"
                    fill="#D80027"
                />
                <path
                    d="M6.63219 3.56164H7.54348L6.69582 4.17746L7.01961 5.17391L6.17199 4.55809L5.32437 5.17391L5.60406 4.31309C4.85773 4.93477 4.20359 5.66313 3.66453 6.47469H3.95652L3.41695 6.86668C3.33289 7.00691 3.25227 7.14937 3.175 7.29395L3.43266 8.08695L2.95195 7.7377C2.83246 7.99086 2.72316 8.24973 2.62492 8.51398L2.90879 9.38773H3.95652L3.10887 10.0036L3.43266 11L2.58504 10.3842L2.0773 10.7531C2.02648 11.1616 2 11.5777 2 12H12C12 6.47719 12 5.82609 12 2C10.0245 2 8.18301 2.57305 6.63219 3.56164ZM7.01961 11L6.17199 10.3842L5.32437 11L5.64816 10.0036L4.80051 9.38773H5.84824L6.17199 8.39129L6.49574 9.38773H7.54348L6.69582 10.0036L7.01961 11ZM6.69582 7.09051L7.01961 8.08695L6.17199 7.47113L5.32437 8.08695L5.64816 7.09051L4.80051 6.47469H5.84824L6.17199 5.47824L6.49574 6.47469H7.54348L6.69582 7.09051ZM10.6066 11L9.75895 10.3842L8.91133 11L9.23512 10.0036L8.38746 9.38773H9.4352L9.75895 8.39129L10.0827 9.38773H11.1304L10.2828 10.0036L10.6066 11ZM10.2828 7.09051L10.6066 8.08695L9.75895 7.47113L8.91133 8.08695L9.23512 7.09051L8.38746 6.47469H9.4352L9.75895 5.47824L10.0827 6.47469H11.1304L10.2828 7.09051ZM10.2828 4.17746L10.6066 5.17391L9.75895 4.55809L8.91133 5.17391L9.23512 4.17746L8.38746 3.56164H9.4352L9.75895 2.5652L10.0827 3.56164H11.1304L10.2828 4.17746Z"
                    fill="#0052B4"
                />
            </g>
            <path
                d="M2.5 12C2.5 6.7533 6.7533 2.5 12 2.5C17.2467 2.5 21.5 6.7533 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.7533 21.5 2.5 17.2467 2.5 12Z"
                stroke="white"
            />
            <defs>
                <clipPath id="clip0_11011_9005">
                    <path
                        d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}
